module.exports = __webpack_public_path__ + "static/img/p-5.d374da8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-5.png
// module id = Z2nj
// module chunks = 0